import * as React from 'react';
import { Box, TextField, Button, Typography, Container, Alert } from '@mui/material';
import emailjs from '@emailjs/browser';

interface FormData {
  name: string;
  company: string;
  email: string;
  message: string;
}

const ContactForm = () => {
  const [formData, setFormData] = React.useState<FormData>({
    name: '',
    company: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = React.useState<{
    type: 'success' | 'error' | null;
    message: string;
  }>({
    type: null,
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      // Replace these with your actual EmailJS service details
      await emailjs.send(
        'service_jpc9vzl',
        'template_2ps17d8',
        {
          from_name: formData.name,
          from_email: formData.email,
          company: formData.company,
          message: formData.message,
        },
        'hrwKdfp8htYaDEVvq'
      );

      setStatus({
        type: 'success',
        message: 'Thank you for your message. We will get back to you soon!',
      });
      
      // Clear form
      setFormData({
        name: '',
        company: '',
        email: '',
        message: '',
      });
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'There was an error sending your message. Please try again.',
      });
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: { xs: 4, md: 6 }, mb: 4 }}>
        <Typography 
          variant="h2" 
          component="h1" 
          gutterBottom
          sx={{
            textAlign: 'center',
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            fontWeight: 600,
            mb: { xs: 3, md: 4 },
            color: 'primary.main',
          }}
        >
          Contact Us
        </Typography>
        
        {status.type && (
          <Alert severity={status.type} sx={{ mb: 2 }}>
            {status.message}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="company"
            label="Company"
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="message"
            label="Message"
            name="message"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleChange}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Send Message
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ContactForm; 